/**
 * Root Component
 */
import React from 'react';
import PropTypes from 'prop-types';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import ErrorBoundary from './components/Error/ErrorBoundary';
import IntlWrapper from './modules/Intl/IntlWrapper';
import BugPage from './modules/Error/pages/BugPage';

// Import Routes
import AppRoutes from './routes';
import './util/icons';

import './assets/css/public.min.css';

// Hack for anchor hash: https://github.com/rafrex/react-router-hash-link/tree/react-router-v2/3
function hashLinkScroll() {
    const { hash } = window.location;
    if(hash !== '') {
        // Push onto callback queue so it runs after the DOM is updated,
        // this is required when navigating from a different page so that
        // the element is rendered on the page before trying to getElementById.
        setTimeout(() => {
            const id = hash.replace('#', '');
            const element = document.getElementById(id);
            if(element) {
                console.log(`Scroll to ${hash}`);
                element.scrollIntoView();
            }
        }, 1000);
    }
}

export default function App({ store, location, context, key = 0, ssr = false, routerComponent = null }) {
    const Router = routerComponent || BrowserRouter;
    return (
        <Provider key={key || 1} store={store}>
            <IntlWrapper>
                <ErrorBoundary errorComponent={BugPage}>
                    <Router location={location} context={context}>
                        <AppRoutes ssr />
                    </Router>
                </ErrorBoundary>
            </IntlWrapper>
        </Provider>
    );
}

App.propTypes = {
    store: PropTypes.object.isRequired,
    location: PropTypes.object.isRequired,
    context: PropTypes.object.isRequired,
    key: PropTypes.number,
    ssr: PropTypes.bool,
    routerComponent: PropTypes.element,
};
